<template>

    <vs-table
      multiple
      v-model="selectedRows"
      :sst="false"
      :data="data"
      noDataText="Sem itens adicionados">

      <template slot="header">
        <label class="vs-input--label"> {{ tableTitle }} </label>
      </template>

      <template slot="thead">
          <template v-for="fieldTitle in titles">
            <vs-th v-if="fieldTitle.name !== 'hash'" :key="fieldTitle.name + Math.random()" :sort-key="fieldTitle.name">{{ $displayLabel(fieldTitle, 'title') }}</vs-th>
          </template>
          <vs-th sort-key="actions">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <template v-for="(field, key) in data[indextr]">
            <vs-td :key="key" :data="field" v-if="key !== hashField">
              {{ field }}
            </vs-td>
          </template>
          <vs-td>
            <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editItem(indextr)"/>
            <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="deleteItem(indextr)"/>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>


</template>

<script>


export default {
  components: {
    
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    titles: {
      type: Array,
      default: () => []
    },
    tableTitle: String,
    onDeleteItem: Function,
    onEditItem: Function,
    fieldHash: String,
    hashField: String
  },
  computed: {
    
  },
  data() {
    return {
      selectedRows: []
    }
  },
  methods: {
    deleteItem(index) {
      this.onDeleteItem(index, this.fieldHash)
    },
    editItem(index) {
      this.onEditItem(index, this.fieldHash)
    }
  },
  watch: {
    selectedRows(val) {
      this.$emit('selectRowsChanged', JSON.stringify({fieldHash: this.fieldHash, value: val}))
    }
  }
}
</script>

<style>

</style>